<template>
  <div>
    <v-row class="ma-0">
      <v-col cols="12" class="d-flex justify-space-between detail-header">
        <div class="inner-wrap">
          <div class="label-title">{{ title }}</div>
          <div class="label-date" v-show="searchDateTerm != ''">
            {{ searchDateTerm }}
          </div>
        </div>
        <v-img :src="iconImgSrc" max-width="71" class="mt-n2"></v-img>
      </v-col>

      <!-- 근무기간선택 버튼 : [근무현황]일때 활성화 -->
      <v-col cols="12" class="py-0 px-5" v-show="selectWorkTermBtn">
        <v-btn
          elevation="0"
          height="38"
          color="#cce3d5"
          class="btn-period"
          @click="onOffModal('select_work_term')"
        >
          <v-icon size="16" class="mr-1">mdi-calendar-range-outline</v-icon>
          근무기간 선택
        </v-btn>
      </v-col>
    </v-row>

    <!---------------------------------------------------------------------------->
    <!-- [모달] 근무기간 선택 -->
    <select-work-term-dialog v-on:selectWorkTermItem="changeWorkTerm">
    </select-work-term-dialog>
  </div>
</template>

<script>
/* 현황 공통타이틀 컴포넌트 */
import SelectWorkTermDialog from '@/components/status/dialog/SelectWorkTermDialog.vue';
import routerConstants from '@/const/routerConstants';
import { getDateTerm } from '@/utils/common/dateUtil.js';
import dayjs from 'dayjs';
import { getWorkCycle } from '@/api/workStatus.js';

export default {
  data: () => ({
    title: '',
    icon: '',
    searchTerm: {
      sdate: '', // 조회시작일자
      edate: '', // 조회종료일자
    },
  }),

  computed: {
    // 조회일자기간
    searchDateTerm() {
      return this.searchTerm.sdate != '' && this.searchTerm.edate != ''
        ? getDateTerm(this.searchTerm.sdate, this.searchTerm.edate)
        : '';
    },

    // 근무기간선택버튼 ([근무현황]에서 사용)
    selectWorkTermBtn() {
      return this.$route.name === routerConstants.WorkTimeSta;
    },

    // 이미지경로
    iconImgSrc() {
      return require(`@/assets/img/${this.icon}_3d@2x.png`);
    },

    // 로그인유저정보
    GET_USER_DATA() {
      return this.$store.getters.GET_USER_DATA;
    },
  },

  methods: {
    /* 모달on/off */
    onOffModal(modalNm) {
      this.$store.commit('DIALOG/TOGGLE_MODAL', modalNm);
    },

    /* 1. 타이틀 세팅 */
    setTitle(staGubun) {
      switch (staGubun) {
        case routerConstants.WorkTimeSta:
          this.title = '근무현황';
          this.icon = 'icon_list_work';
          break;
        case routerConstants.WorkOverTimeSta:
          this.title = '연장근무 보상시간';
          this.icon = 'icon_list_overtime';
          break;
        case routerConstants.MaternityHolidaySta:
          this.title = '배우자 출산휴가';
          this.icon = 'icon_list_birth';
          break;
        case routerConstants.AnnualHolidaySta:
          this.title = '연차휴가현황';
          this.icon = 'icon_list_paidholiday';
          break;
      }
    },

    /* 2. 조회기간 세팅 */
    setTerm(staGubun) {
      const now = dayjs();

      if (staGubun === routerConstants.WorkOverTimeSta) {
        // [연장근무보상시간현황]
        return;
      }
      if (staGubun === routerConstants.WorkTimeSta) {
        // [근무현황]
        this.fetchWorkCycle(now);
      } else {
        // [그외]
        // 기본 : 당해연도
        this.searchTerm.sdate = `${now.format('YYYY')}0101`;
        this.searchTerm.edate = `${now.format('YYYY')}1231`;
        this.$emit('setSearchParam', { searchTerm: this.searchTerm });
      }
    },

    /* 근무기간변경 ([근무현황]에서 사용) */
    changeWorkTerm(item) {
      this.searchTerm.sdate = item.sYmd;
      this.searchTerm.edate = item.eYmd;
      this.$emit('setSearchParam', {
        searchTerm: this.searchTerm,
        workCycleCd: item.workCycleCd,
      });
    },

    /* 근무주기조회 ([근무현황]에서 사용) */
    async fetchWorkCycle(date) {
      try {
        const response = await getWorkCycle({
          searchYmd: date.format('YYYYMMDD'),
        });
        const dataObj = response.data.data;

        if (dataObj != null) {
          this.searchTerm.sdate = dataObj.sYmd;
          this.searchTerm.edate = dataObj.eYmd;

          this.$emit('setSearchParam', {
            searchTerm: this.searchTerm,
            workCycleCd: dataObj.workCycleCd,
          });
        } else {
          alert('근무정보가 없습니다.');
          // 공통 스피너 OFF
          this.$store.commit('SPINNER/OFF_COMMON_SPINNER');
        }
      } catch (error) {
        console.log(error);
      }
    },
  },

  created() {
    this.setTitle(this.$route.name);
    this.setTerm(this.$route.name);
  },

  components: {
    SelectWorkTermDialog,
  },
};
</script>

<style>
/* dialog */
/*.v-dialog:not(.v-bottom-sheet) {
  background-color: white;
  height: inherit;
}*/
</style>
